export default defineNuxtPlugin((nuxtApp) => {
  const maxReload = 10
  const chunkErrorReloads = useLocalStorage('chunkErrorReloads', 0)
  const log = useAgsLog('routeChunkErrorHandler')

  nuxtApp.hook('app:chunkError', ({ error }) => {
    const reloads = chunkErrorReloads.get()
    if (reloads < maxReload) {
      log.error(`Caught chunk load error, reloading shop (count: ${reloads})`, {
        error,
      })
      chunkErrorReloads.set(reloads + 1)
      reloadNuxtApp()
    } else {
      log.error('Caught chunk load error, reload entered a loop', { error })
    }
  })
})
